export const ADMIN_FEATURE_KEY = 'admin';
